import { initValidate } from 'libs/validate'
import { selectAll } from 'helpers/dom'

class ValidateForm extends HTMLElement {
  constructor() {
    super()
    this.submitDelay = this.hasAttribute('data-submit-delay')
    this.stopPropagation = this.hasAttribute('data-stop-propagation')
  }

  connectedCallback() {
    const formIds = this.getFormIds()

    if (formIds.length) {
      formIds.forEach((form) => {
        if (form && selectAll('input:not([type=hidden]), select', form).length) {
          this.validate = initValidate(form)
          this.trackingRemoveAttributeForm(form)

          if (this.stopPropagation) {
            form.addEventListener('submit', (e) => {
              if (!this.validate?.isValid) {
                e.preventDefault()
                e.stopImmediatePropagation()

                return false
              }
            })
          }

          if (!this.submitDelay) {
            this.validate.onSuccess((event) => {
              form.submit(event)
            })
          }
        }
      })
    }
  }

  trackingRemoveAttributeForm(form, attribute = 'onsubmit') {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === attribute) {
            form.removeAttribute(attribute)
          }
        }
      }
    })

    observer.observe(form, { attributes: true })
  }

  getInstance() {
    return this.validate
  }

  refreshValidate() {
    this.validate.refresh()
  }

  revalidate(success, failed) {
    this.validate.revalidate().then((isValid) => {
      if (isValid && typeof success === 'function') success()
      else if (!isValid && typeof failed === 'function') failed()
    })
  }

  getFormIds() {
    const els = selectAll('form', this)

    return els
  }
}

customElements.define('validate-form', ValidateForm)
